import { z } from 'zod';

import { uuidSchema } from './common.js';

export const accessMatrixEntrySchema = z.object({
  userId: uuidSchema,
  clientId: uuidSchema,
  allowed: z.boolean(),
});
export type AccessMatrixEntryDto = z.infer<typeof accessMatrixEntrySchema>;

export const updateAccessMatrixSchema = z.object({
  entries: z.array(accessMatrixEntrySchema),
});
export type UpdateAccessMatrixDto = z.infer<typeof updateAccessMatrixSchema>;
